import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { AuthSplitLayout } from 'src/layouts/auth-split';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------
const Amplify = {
  SignInPage: lazy(() => import('src/pages/auth/amplify/sign-in')),
};

const authAmplify = {
  path: 'sign-in',
  element: (
    <GuestGuard>
      <AuthSplitLayout
        slotProps={{
          section: { title: 'Welcome to Xpanse!' },
        }}
      >
        <Amplify.SignInPage />
      </AuthSplitLayout>
    </GuestGuard>
  ),
};

// ----------------------------------------------------------------------

export const authRoutes: RouteObject[] = [
  {
    path: 'portal',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [authAmplify],
  },
];
